import { render, staticRenderFns } from "./AffectedUsers.vue?vue&type=template&id=b24c7e06&"
import script from "./AffectedUsers.vue?vue&type=script&lang=js&"
export * from "./AffectedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports